export const formatoMoneda = (arg: number, sinDecimales?: boolean, sinSimbolo?: boolean): string => {
    const opt: Intl.NumberFormatOptions | undefined = sinDecimales ? undefined : {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }

    const prefijo = sinSimbolo? '' : '$ '

    return prefijo + Intl.NumberFormat('es-AR', opt).format(arg)
}